<template>
  <header>
    <nav-select :users="getListChildrenSelectFormat" @onChangeAction="handleChildChange" />
    <nav-subtitle :title="'Check child challenge'" :icon="'playlist_add_check'" class="mb-3" />
  </header>
</template>
<script>
import { mapGetters } from 'vuex';
import store from '@/store';

import NavSelect from '@/components/general/navSelect.vue';
import NavSubtitle from '@/components/general/navSubtitle.vue';

export default {
  components: {
    NavSelect,
    NavSubtitle,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const userId = store.getters['user/getUserId'];
      await Promise.all([store.dispatch('parent/FetchChildrenData', userId)]);
    } catch (error) {
      console.error(error);
    } finally {
      next();
    }
  },
  computed: {
    ...mapGetters('parent', ['getListChildrenSelectFormat']),
  },
  methods: {
    handleChildChange(childId) {
      this.$router.push({ name: 'challengeParentApprove', params: { childId } });
    },
  },
};
</script>
